var _rect, _rect2, _text, _line, _rect3, _path, _text2, _rect4, _path2, _text3, _rect5, _path3, _text4, _rect6, _text5, _rect7, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiseChecklistOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 220,
    rx: 14,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 220,
    rx: 14,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 26,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, "MISE EN PLACE CHECKLIST")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 38,
    x2: 184,
    y2: 38,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#335CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 61L24 64L31 57",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 65,
    fill: "rgba(0, 0, 0, 0.35)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    textDecoration: "line-through"
  }, "Fresh Herbs")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 82,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#335CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91L24 94L31 87",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 95,
    fill: "rgba(0, 0, 0, 0.35)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    textDecoration: "line-through"
  }, "Flatbread Base")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 112,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#335CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 121L24 124L31 117",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 125,
    fill: "rgba(0, 0, 0, 0.35)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    textDecoration: "line-through"
  }, "Spiced Filling")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 142,
    width: 18,
    height: 18,
    rx: 4,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.25)",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 155,
    fill: "rgba(0, 0, 0, 0.85)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500
  }, "Dry Spice Blends")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 172,
    width: 18,
    height: 18,
    rx: 4,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.25)",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 185,
    fill: "rgba(0, 0, 0, 0.85)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500
  }, "Aromatics")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiseChecklistOverlay);
export default __webpack_public_path__ + "static/media/mise-checklist-overlay.bb840ee8278ea1bd40036209f269e854.svg";
export { ForwardRef as ReactComponent };